<template>
  <div class="rmr-page-shell social-revenues-page">
    <rmr-page-hero
      title="Revenus"
      title-accent="Sociaux"
      subtitle="Suivi mensuel des revenus issus des plateformes sociales"
      :icon="icons.mdiCurrencyEur"
    >
      <template #actions>
        <social-reporting-health />
      </template>
    </rmr-page-hero>

    <section class="rmr-page-shell__content social-revenues-page__content">
      <div class="rmr-table-shell social-revenues-page__panel">
        <div class="social-revenues-page__tabs">
          <rmr-tabs v-model="activeTab" :tabs="networkTabs" show-arrows />
        </div>

        <social-revenue-matrix :network="activeNetwork" />
      </div>
    </section>
  </div>
</template>

<script>
import {
  mdiCurrencyEur,
  mdiFacebook,
  mdiGhost,
  mdiMusicNote,
  mdiYoutube,
} from "@mdi/js";
import SocialRevenueMatrix from "@/components/audience/social-reporting/SocialRevenueMatrix.vue";
import SocialReportingHealth from "@/components/audience/social-reporting/SocialReportingHealth.vue";
import {
  readQueryString,
  replaceQueryParams,
} from "@/components/audience/social-reporting/queryState";
import RmrPageHero from "@/components/ui/layout/RmrPageHero.vue";
import RmrTabs from "@/components/ui/layout/RmrTabs.vue";
import { saveRmraView } from "@/utils/rmr-analytics";

const NETWORKS = [
  { value: "facebook", label: "Facebook", icon: mdiFacebook },
  { value: "youtube", label: "YouTube", icon: mdiYoutube },
  { value: "tiktok", label: "TikTok", icon: mdiMusicNote },
  { value: "snapchat", label: "Snapchat", icon: mdiGhost },
];

export default {
  name: "SocialReportingRevenues",
  components: {
    RmrPageHero,
    RmrTabs,
    SocialRevenueMatrix,
    SocialReportingHealth,
  },
  data() {
    const requestedNetwork = readQueryString(this.$route.query.network);
    const activeTab = NETWORKS.some(
      (network) => network.value === requestedNetwork
    )
      ? NETWORKS.findIndex((network) => network.value === requestedNetwork)
      : 0;
    return {
      activeTab,
      icons: { mdiCurrencyEur },
      networks: NETWORKS,
    };
  },
  computed: {
    activeNetwork() {
      return this.networks[this.activeTab].value;
    },
    networkTabs() {
      return this.networks.map((network) => ({
        key: network.value,
        label: network.label,
        icon: network.icon,
      }));
    },
  },
  watch: {
    activeTab(value) {
      replaceQueryParams(this.$router, this.$route, ["network"], {
        network: this.networks[value].value,
      });
    },
    "$route.query.network"(value) {
      const requestedNetwork = readQueryString(value);
      const nextTab = this.networks.findIndex(
        (network) => network.value === requestedNetwork
      );
      const normalizedTab = nextTab >= 0 ? nextTab : 0;
      if (normalizedTab !== this.activeTab) this.activeTab = normalizedTab;
    },
  },
  mounted() {
    saveRmraView(this.$route);
  },
};
</script>

<style lang="scss" scoped>
.social-revenues-page__content {
  padding-bottom: $rmr-space-xl;
}

.social-revenues-page__panel {
  background: $rmr-surface-0;

  ::v-deep .social-revenue-table {
    border-radius: 0 !important;
    box-shadow: none !important;
  }
}

.social-revenues-page__tabs {
  padding: 0;
  background: $rmr-surface-0;
}
</style>
